/**
 * InfoTooltip — small accessible info-icon with hover + tap tooltip.
 *
 * iter98 — used on Lead Detail page next to "Unlock Attempts" and
 * "Intent Score". CSS-only, no Radix provider needed. The trigger is
 * focusable so it works on mobile (tap toggles :focus-visible) and via
 * keyboard.
 */
import { Info } from "lucide-react";

const InfoTooltip = ({ children, label = "More info", testId, side = "top", maxWidth = 280 }) => {
  // Positioning: bottom variants flip the tooltip below the trigger.
  const positionClasses =
    side === "bottom"
      ? "top-full mt-2"
      : side === "right"
      ? "left-full ml-2 top-1/2 -translate-y-1/2"
      : "bottom-full mb-2";

  return (
    <span
      className="relative inline-flex items-center align-middle ml-1 group"
      data-testid={testId}
    >
      <button
        type="button"
        aria-label={label}
        className="inline-flex items-center justify-center text-gray-400 hover:text-gray-600 focus:text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-300 rounded-full"
        tabIndex={0}
      >
        <Info className="w-3.5 h-3.5" aria-hidden />
      </button>
      <span
        role="tooltip"
        className={`pointer-events-none opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-150 absolute left-1/2 -translate-x-1/2 ${positionClasses} px-3 py-2 bg-gray-900 text-white text-[11px] leading-snug rounded-md shadow-lg z-30 whitespace-normal text-left font-normal`}
        style={{ width: `${maxWidth}px` }}
        data-testid={testId ? `${testId}-content` : undefined}
      >
        {children}
        <span
          aria-hidden
          className={`absolute left-1/2 -translate-x-1/2 ${side === "bottom" ? "bottom-full -mb-1" : "top-full -mt-1"} w-2 h-2 bg-gray-900 rotate-45`}
        />
      </span>
    </span>
  );
};

export default InfoTooltip;
